import { render } from "./Certificates.vue?vue&type=template&id=150f81a8"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__